import { jsx as t } from "react/jsx-runtime";
import { GridViewImageGallery as e } from "@nextgen-web-framework/all";
const a = ({ images: r, imagesPerRow: o }) => /* @__PURE__ */ t(e, { ...{
  images: r,
  imagesPerRow: o
} });
export {
  a as default
};
//# sourceMappingURL=GridViewImageGallery.js.map
